import { c as _c } from "react/compiler-runtime";
import { Formik } from 'formik';
import { useContext } from 'react';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import { ApiKey } from '../../../../../../../../typings/ApiKey.interface';
import { ApiKeyScopeFormValues, ApiKeyScopesFields, getInitialScopeValues, scopesFromScopeValues } from '../../../../common/ApiKeys/ApiKeyScopesFields';
import TextInput from '../../../../common/Form/Fields/TextInput';
import { Div } from '../../../../common/helpers/StyledUtils';
import Modal from '../../../../common/Modal';
import { useToasts } from '../../../../common/Toast';
import { GlobalContext } from '../../../../contexts/GlobalContext';
import { DashboardContext } from '../../DashboardContext';
interface FormValues extends ApiKeyScopeFormValues {
  label: string;
}
interface Props {
  onApiKeyCreated: (api_key: ApiKey) => void;
}
export function AddTeamApiKeyModal(t0) {
  const $ = _c(18);
  const {
    onApiKeyCreated
  } = t0;
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const {
    team
  } = useContext(DashboardContext);
  const history = useHistory();
  const location = useLocation();
  const {
    addToast
  } = useToasts();
  let t1;
  if ($[0] !== team) {
    t1 = team ? [team.type] : [];
    $[0] = team;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const project_types = t1;
  let t2;
  if ($[2] !== history || $[3] !== location.search) {
    t2 = () => {
      history.push({
        pathname: "/settings/project/secrets",
        search: location.search,
        state: {
          scroll: false
        }
      });
    };
    $[2] = history;
    $[3] = location.search;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const onClose = t2;
  const validate = _temp;
  let t3;
  if ($[5] !== HookdeckAPI || $[6] !== addToast || $[7] !== onApiKeyCreated || $[8] !== onClose || $[9] !== project_types) {
    t3 = async values_0 => {
      ;
      try {
        const api_key = await HookdeckAPI.teams.createApiKey({
          label: values_0.label.trim(),
          scopes: scopesFromScopeValues("project", values_0, project_types)
        });
        onApiKeyCreated(api_key);
        addToast("success", "API key created");
        onClose();
      } catch (t4) {
        const err = t4;
        addToast("error", err.message);
      }
    };
    $[5] = HookdeckAPI;
    $[6] = addToast;
    $[7] = onApiKeyCreated;
    $[8] = onClose;
    $[9] = project_types;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const onSubmit = t3;
  let t4;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      label: "",
      ...getInitialScopeValues("project")
    };
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== onClose || $[13] !== project_types) {
    t5 = props => <form onSubmit={props.handleSubmit}><Modal title="Create API Key" submit_label="Create API Key" cancel_label="Cancel" hide_close={true} onSubmit={props.handleSubmit} onCancel={onClose} onClose={onClose} is_submitting={props.isSubmitting} submit_disabled={!props.isValid}><Div flex={{
          direction: "column",
          gap: 4
        }}><TextInput name="label" label="Name" placeholder="e.g. CI pipeline" auto_complete="off" focus={true} /><ApiKeyScopesFields tier="project" project_types={project_types} /></Div></Modal></form>;
    $[12] = onClose;
    $[13] = project_types;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== onSubmit || $[16] !== t5) {
    t6 = <Formik initialValues={t4} onSubmit={onSubmit} validate={validate} validateOnMount={true}>{t5}</Formik>;
    $[15] = onSubmit;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
function _temp(values) {
  const errors = {};
  if (!values.label?.trim()) {
    errors.label = "Required";
  }
  return errors;
}